import { milhar } from './format';

// Pedido de aumento antes de fechar a compra (próximo múltiplo de 5).
// "Sim" e "Não, permanecer" seguem para o pedido — com a quantidade sugerida
// ou com a original. Fechar o diálogo (X, clique fora, Esc) é desistir: volta
// para a página sem criar pedido.
export default function createUpsell(overlay, { show, hide, total, onConfirm }) {
  const find = (selector) => overlay.querySelector(selector);
  const fill = (selector, text) => overlay.querySelectorAll(selector).forEach((el) => { el.textContent = text; });
  let choice = null;

  function ask(current, suggested) {
    choice = { current, suggested };
    fill('[data-up-suggested]', milhar(suggested));
    fill('[data-up-current]', milhar(current));
    fill('[data-up-total]', total(suggested));
    show(overlay, find('#upsellYes'));
  }

  function answer(accepted) {
    if (!choice) return;
    const { current, suggested } = choice;
    choice = null;
    hide(overlay);
    onConfirm(accepted ? suggested : current);
  }

  function cancel() {
    if (!choice) return;
    choice = null;
    hide(overlay);
  }

  find('#upsellYes').addEventListener('click', () => answer(true));
  find('#upsellNo').addEventListener('click', () => answer(false));
  find('#upsellX').addEventListener('click', cancel);
  overlay.addEventListener('click', (event) => { if (event.target === overlay) cancel(); });

  return { ask, cancel, isOpen: () => Boolean(choice) };
}
